export const getPercentage = (num, dem) => {
  if (num <= 0) return 0;
  return ((num / (dem || 1)) * 100).toFixed(1);
};
